import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';
import LoadingScreen from '../components/ui/LoadingScreen';

/** Legacy route — card registry lives under Settings → Integrations → Sequence. */
const DebitCardSettingsPage: React.FC = () => {
  const { user, loading } = useAuth();

  if (loading) return <LoadingScreen />;
  if (!user || user.role !== 'admin') return <Navigate to="/finances/project-pl" replace />;

  return <Navigate to="/settings/integrations#sequence-cards" replace />;
};

export default DebitCardSettingsPage;
